// extracted by mini-css-extract-plugin
export default {"component":"F+02s"};